"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyLocationSchema = void 0;
exports.propertyLocationSchema = {
    type: ['object', 'null'],
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'additionalStreetNumber',
        'blockLegalDescriptionEnglish',
        'concessionLegalDescriptionText',
        'statisticsCanadaCensusDivisionID',
        'statisticsCanadaCensusSubdivisionID',
        'lotLegalDescriptionText',
        'levelLegalDescriptionText',
        'multipleListingServiceZoneTypeCode',
        'municipalityName',
        'planLegalDescriptionText',
        'propertyAddressMunicipalityName',
        'propertyAddressPostalCode',
        'propertyAddressProvinceName',
        'propertyAddressStreetDirectionID',
        'propertyAddressStreetName',
        'propertyAddressStreetNumber',
        'propertyAddressStreetTypeID',
        'propertyAddressUnitNumber',
        'statisticsCanadaProvinceID',
        'streetNameKey',
        'townshipLegalDescriptionText',
        'unitLegalDescriptionText',
        'vacancyZoneTypeCode',
        'cmhcLoanAccountNumber',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
    ],
    properties: {
        additionalStreetNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 30,
            errorMessage: 'should have variable length up to 30 characters',
        },
        blockLegalDescriptionEnglish: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        concessionLegalDescriptionText: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        statisticsCanadaCensusDivisionID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        statisticsCanadaCensusSubdivisionID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        lotLegalDescriptionText: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have variable length up to 20 characters',
        },
        levelLegalDescriptionText: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        multipleListingServiceZoneTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        municipalityName: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        planLegalDescriptionText: {
            type: 'string',
            minLength: 0,
            maxLength: 12,
            errorMessage: 'should have variable length up to 12 characters',
        },
        propertyAddressMunicipalityName: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have variable length up to 20 characters',
        },
        propertyAddressPostalCode: {
            type: 'string',
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        propertyAddressProvinceName: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        propertyAddressStreetDirectionID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        propertyAddressStreetName: {
            type: 'string',
            minLength: 0,
            maxLength: 30,
            errorMessage: 'should have variable length up to 30 characters',
        },
        propertyAddressStreetNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
        },
        propertyAddressStreetTypeID: {
            type: 'string',
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        propertyAddressUnitNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        statisticsCanadaProvinceID: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        streetNameKey: {
            type: 'string',
            minLength: 0,
            maxLength: 10,
            errorMessage: 'should have maximum length of 10 characters',
        },
        townshipLegalDescriptionText: {
            type: 'string',
            minLength: 0,
            maxLength: 6,
            errorMessage: 'should have maximum length of 6 characters',
        },
        unitLegalDescriptionText: {
            type: 'string',
            minLength: 0,
            maxLength: 4,
            errorMessage: 'should have maximum length of 4 characters',
        },
        vacancyZoneTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        cmhcLoanAccountNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
    },
};
